<template>
  <div class="rContainer">
    <dl class="bsTitleBox">
      <dt class="bsTitle">
        开关设置
      </dt>
    </dl>
    <div class="switchBox">
      <dl class="switchinner">
        <dt>季度入口开关</dt>
        <dd>
          <span>上季度业绩目标开关</span>
          <a-switch
            :checked="checkArr.lastOkrSwitch"
            @change="(e) => onChange(e, 0)"
          />
        </dd>
        <dd>
          <span>上季度自评开关</span>
          <a-switch
            :checked="checkArr.lastSelfEvaSwitch"
            @change="(e) => onChange(e, 2)"
          />
        </dd>
        <dd>
          <span>上季度主管评开关</span>
          <a-switch
            :checked="checkArr.lastDireEvaSwitch"
            @change="(e) => onChange(e, 3)"
          />
        </dd>
        <dd>
          <span>上季度面谈纪要开关</span>
          <a-switch
            :checked="checkArr.lastInterViewSwitch"
            @change="(e) => onChange(e, 5)"
          />
        </dd>
        <dd>
          <span>上季度回传合议结果开关</span>
          <a-switch
            :checked="checkArr.lastDiscussSwitch"
            @change="(e) => onChange(e, 4)"
          />
        </dd>
        <dd>
          <span>本季度业绩目标开关</span>
          <a-switch
            :checked="checkArr.currentOkrSwitch"
            @change="(e) => onChange(e, 1)"
          />
        </dd>
      </dl>
      <dl class="switchinner">
        <dt>
          <span>年度入口开关</span>
          <a-select
            v-model="selectValue"
            placeholder="请选择年度"
            class="chooseBox"
            @change="chooseYear"
          >
            <a-select-option
              v-for="(y,index) in years"
              :key="index"
            >
              {{ y }}
            </a-select-option>
          </a-select>
        </dt>
        <dd
          v-for="(i,index) in yearArr"
          :key="index"
        >
          <span>{{ yearSwitchTitle[index] }}</span>
          <a-switch
            :checked="i.switchOn"
            @change="(e) => onChangeYear(e, index+1)"
          />
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Switch, message, Select } from 'ant-design-vue'

Vue.use(Switch)
Vue.use(Select)

export default {
  name: 'SwitchSet',
  data() {
    return {
      checkArr: [],
      yearSwitchTitle: ['年度自评开关', '年度主管评开关', '年度面谈纪要开关', '年度回传合议结果开关'],
      yearArr: [],
      selectValue: undefined,
      year: 0,
      years: [],
    }
  },
  created() {
    this.getSwitchData()
    // 设置年度开关的当前年和选项逻辑：当前月份小于6月，当前年展示为上一年；年度选项从2020年起直到当前年份；
    const myDate = new Date()
    const year = myDate.getFullYear()
    const month = myDate.getMonth() + 1
    if (month < 6) {
      this.year = year - 1
    } else {
      this.year = year
    }
    for (let y = 2020; y <= year; y++) {
      this.years.push(`${y}`)
    }
    this.selectValue = `${this.year}`
    // eslint-disable-next-line
    console.log('this.years',this.years)
    this.getYearSwitchData(this.year)
    // this.selectValue = year
  },
  methods: {
    // 获取季度开关配置
    async getSwitchData() {
      try {
        const result = await this.$api.backstage.getSwitch()
        this.$set(this, 'checkArr', result)
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      }
    },
    // 获取年度开关配置
    async getYearSwitchData(year) {
      try {
        const result = await this.$api.backstage.getYearSwitch({
          year,
        })
        this.$set(this, 'yearArr', result)
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      }
    },
    chooseYear(e) {
      // eslint-disable-next-line
      console.log(e, typeof(e), this.selectValue)
    },
    async onChange(checked, k) {
      // eslint-disable-next-line
      console.log('开关', checked, k)
      const { checkArr } = this
      switch (k) {
        case 0:
          checkArr.lastOkrSwitch = checked
          break
        case 1:
          checkArr.currentOkrSwitch = checked
          break
        case 2:
          checkArr.lastSelfEvaSwitch = checked
          break
        case 3:
          checkArr.lastDireEvaSwitch = checked
          break
        case 4:
          checkArr.lastDiscussSwitch = checked
          break
        case 5:
          checkArr.lastInterViewSwitch = checked
      }
      try {
        await this.$api.backstage.setSwitch({
          type: k,
          status: checked,
        })
        await this.getSwitchData()
        message.success('操作成功！')
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      }
    },
    async onChangeYear(checked, k) {
      // eslint-disable-next-line
      console.log('year开关', checked, k)
      const { yearArr } = this
      yearArr[k - 1].switchOn = checked
      try {
        const result = await this.$api.backstage.setYearSwitch({
          type: k,
          switchOn: checked,
          year: this.year,
        })
        yearArr[result.type - 1].switchOn = result.switchOn
        message.success('操作成功！')
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.switchBox{padding: 24px 24px 0;
&>dl{padding-bottom: 40px;}
dt{font-size: 16px; margin-bottom: 30px;}
dd{margin-bottom: 40px; display:flex; align-items: center;
span{display:inline-block; width:180px; text-align: right; margin-right: 40px;}}
}
.chooseBox{width:120px; margin-left: 45px;}
</style>
